import { UserProfileBoxComponent } from "./user-profile-box/user-profile-box.component";
import { UserProfileLanguageComponent } from "./user-profile-language/user-profile-language.component";
import { UserProfileComponent } from "./user-profile.component";

export {
  UserProfileComponent,
  UserProfileBoxComponent,
  UserProfileLanguageComponent,
};

export const userProfileComponents = [
    UserProfileComponent,
    UserProfileBoxComponent,
    UserProfileLanguageComponent,
]
